import { Flex, Text, Input, Button, Tooltip } from '@chakra-ui/react'
import { Card } from './Card'
import { formatDate } from '../../../../utils/formatDate'
import { formatPrice } from '../../../../utils/formatPrice'
import { useState } from 'react'
import { TooltipUsage } from '../../../../components/Tooltip/TooltipUsage'

export const InfoDevolucao = ({ data, register, errors }) => {
  console.log('data', data)
  const [email, setEmail] = useState([])

  const emailList = email.map((item, index) => (
    <>
      <Input
        autoFocus
        placeholder="Email não obrigatório"
        maxW="20rem"
        {...register(`email_${index}`)}
        key={index}
      />
      {errors && (
        <Text color="red.500">{errors[`email_${index}`]?.message}</Text>
      )}
    </>
  ))

  function addEmail() {
    if (email.length === 2) {
      return
    }

    setEmail([...email, ''])
  }

  function removeEmail() {
    const emailRemoved = email.filter(
      (item, index) => index !== email.length - 1
    )

    setEmail(emailRemoved)
  }

  return (
    <Flex flexDir="column">
      <Flex alignItems="center" justifyContent="space-between">
        <Flex flexDir="column">
          <Flex alignItems="center" gap=".6rem">
            <Text color="#378BBF">Data do pedido: </Text>{' '}
            <Text>
              {data.data_pedido
                ? formatDate(data.data_pedido)
                : 'Não informado'}
            </Text>
          </Flex>
          <Flex alignItems="center" gap=".6rem">
            <Text color="#378BBF">Data devolução: </Text>{' '}
            <Text>
              {data.data_devolucao
                ? formatDate(data.data_devolucao)
                : 'Não informado'}
            </Text>
          </Flex>
          <Flex alignItems="center" gap=".6rem">
            <Text color="#378BBF">Saída da mercadoria: </Text>{' '}
            <Text>
              {data.data_saida_mercadoria
                ? formatDate(data.data_saida_mercadoria)
                : 'Não informado'
              }
            </Text>
          </Flex>
        </Flex>
        <Flex gap={1}>
          <TooltipUsage
            color="#378BBF"
            label={
              email.length === 2
                ? 'Você já adicionou o máximo de emails'
                : `Adicionar email  ${email.length + 2}`
            }
          >
            <Button
              colorScheme="blue"
              onClick={addEmail}
              disabled={email.length === 2}
            >
              +
            </Button>
          </TooltipUsage>

          {email.length > 0 && (
            <TooltipUsage
              color="red"
              label={`Remover email ${email.length + 1}`}
            >
              <Button colorScheme="red" onClick={removeEmail}>
                -
              </Button>
            </TooltipUsage>
          )}
          <Flex flexDir="column" gap={1}>
            <Input
              autoFocus
              placeholder="Email secundário"
              maxW="20rem"
              {...register('email')}
            />
            {errors && <Text color="red.500">{errors.email?.message}</Text>}

            {emailList}
          </Flex>
        </Flex>
      </Flex>

      <Flex
        alignItems="center"
        justifyContent="space-between"
        mt="1rem"
        gap={2}
      >
        <Card label="Pedido venda" value={data.pedido_venda} />
        <Card label="Pedido Compra" value={data.pedido_compra} />
        <Card
          label="Cod"
          value={data.codigo_produto ? data.codigo_produto : 'Não'}
        />
        <Card label="Descrição" value={data.descricao} />
      </Flex>
      <Flex justifyContent="space-between" mt="1rem">
        <Card label="Cor" value={data.cor_produto} />
        <Card
          label="Nº Pedido troca"
          value={`${data.pedido_troca} - ${data.sequencia}`}
        />
        <Card
          label="Valor Unitário"
          value={formatPrice(data.valor_unitario_pedido)}
        />
        <Card
          label="Valor Total"
          value={formatPrice(data.valor_total_pedido)}
        />
      </Flex>
      <Flex
        mt="1rem"
        border="1px solid #ccc"
        px="1rem"
        py=".5rem"
        borderRadius=".3rem"
      >
        <Card
          label="Fornecedor"
          value={data.fornecedor}
          border={false}
          bold={true}
        />
        <Card
          label="Peças com defeito"
          value={data.quantidade_troca}
          border={false}
          bold={true}
        />
        <Card
          label="Cód. fornecedor"
          value={data.cod_fornecedor ? data.cod_fornecedor : 'Não informado'}
          border={false}
          bold={true}
        />
        <Card
          label="Pedido fornecedor"
          value={data.pedidoVenda}
          border={false}
          bold={true}
          pedidoFornecedor={true}
          register={register}
          errors={errors}
        />
      </Flex>
    </Flex>
  )
}
